export const GET_USER_PROFILE_PROCESS = 'GET_USER_PROFILE_PROCESS';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_START = 'GET_USER_PROFILE_START';
